// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShopDeviceList_lightAccent__jLicp {
  background-color: #eaeaea;
  color: black;
  transition: background-color 0.35s, color 0.35s;
}

.ShopDeviceList_customButton__yffUz {
  padding: 0 35px;
  height: 49.2px;
}
.ShopDeviceList_customButton__yffUz.ShopDeviceList_buttonWithCircles__BL85S:hover .ShopDeviceList_circleContainer__hKfXl .ShopDeviceList_circle__F7QPQ {
  background: radial-gradient(circle, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.2));
}

.ShopDeviceList_buttonWithArrow__X59au {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: space-between;
}

.ShopDeviceList_filterButton__IKXaV {
  border-radius: 10px;
}

.ShopDeviceList_lightAccent__jLicp:hover {
  background-color: #ff6f19;
  color: white;
}

.ShopDeviceList_customSvg__UgQiI {
  fill: black;
  transition: fill 0.35s, color 0.35s;
}

.ShopDeviceList_customSvg__UgQiI:hover {
  fill: white;
}

.ShopDeviceList_customArrow__RF4RL {
  stroke: black;
  transition: stroke 0.35s, transform 0.35s, top 0.35s, color 0.35s;
}

.ShopDeviceList_rotateCustomArrow__FY-fe {
  top: 4px;
  transform: rotate(-45deg);
}

.ShopDeviceList_buttonWithArrow__X59au:hover .ShopDeviceList_customArrow__RF4RL {
  stroke: white;
}

.ShopDeviceList_searchInput__4lDmx::placeholder {
  font-size: 0.9rem;
}

@keyframes ShopDeviceList_expand__GP2NL {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.5/2);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}
.ShopDeviceList_circle__F7QPQ:nth-child(1) {
  animation-delay: 0s;
}

.ShopDeviceList_circle__F7QPQ:nth-child(2) {
  animation-delay: 1s;
}

.ShopDeviceList_circle__F7QPQ:nth-child(3) {
  animation-delay: 2s;
}

.ShopDeviceList_circle__F7QPQ:nth-child(4) {
  animation-delay: 3s;
}

.ShopDeviceList_circle__F7QPQ:nth-child(5) {
  animation-delay: 4s;
}

.ShopDeviceList_circle__F7QPQ {
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(0, 0, 0, 0.4), rgba(255, 255, 255, 0.2));
  border-radius: 50%;
  animation-name: ShopDeviceList_expand__GP2NL;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: 5s;
  pointer-events: none;
  opacity: 0;
}

@media (max-width: 728px) {
  .ShopDeviceList_lightAccent__jLicp:hover {
    background-color: #eaeaea;
    color: black;
  }
  .ShopDeviceList_customSvg__UgQiI:hover {
    fill: black;
  }
  .ShopDeviceList_buttonWithArrow__X59au:hover .ShopDeviceList_customArrow__RF4RL {
    stroke: black;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/ShopDeviceList/ShopDeviceList.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,YAAA;EACA,+CAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;AAIM;EACE,uFAAA;AAFR;;AASA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,yBAAA;EACA,YAAA;AANF;;AASA;EACE,WAAA;EACA,mCAAA;AANF;;AASA;EACE,WAAA;AANF;;AASA;EACE,aAAA;EACA,iEAAA;AANF;;AASA;EACE,QAAA;EACA,yBAAA;AANF;;AASA;EACE,aAAA;AANF;;AAUE;EACE,iBAAA;AAPJ;;AAYA;EACE;IACE,mBAAA;IACA,UAAA;EATF;EAYA;IACE,uBAAA;IACA,UAAA;EAVF;EAaA;IACE,qBAAA;IACA,UAAA;EAXF;AACF;AAeE;EACE,mBAAA;AAbJ;;AAYE;EACE,mBAAA;AATJ;;AAQE;EACE,mBAAA;AALJ;;AAIE;EACE,mBAAA;AADJ;;AAAE;EACE,mBAAA;AAGJ;;AACA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iFAAA;EACA,kBAAA;EACA,4CAAA;EACA,iCAAA;EACA,mCAAA;EACA,sBAAA;EACA,oBAAA;EACA,UAAA;AAEF;;AACA;EACE;IACE,yBAAA;IACA,YAAA;EAEF;EACA;IACE,WAAA;EACF;EAEA;IACE,aAAA;EAAF;AACF","sourcesContent":[".lightAccent {\n  background-color: #eaeaea;\n  color: black;\n  transition: background-color 0.35s, color 0.35s;\n}\n\n.customButton {\n  padding: 0 35px;\n  height: 49.2px;\n\n  &.buttonWithCircles:hover {\n\n    .circleContainer {\n      .circle {\n        background: radial-gradient(circle, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.2));\n      }\n    }\n\n  }\n}\n\n.buttonWithArrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  justify-content: space-between;\n}\n\n.filterButton {\n  border-radius: 10px;\n}\n\n.lightAccent:hover {\n  background-color: #ff6f19;\n  color: white;\n}\n\n.customSvg {\n  fill: black;\n  transition: fill 0.35s, color 0.35s;\n}\n\n.customSvg:hover {\n  fill: white;\n}\n\n.customArrow {\n  stroke: black;\n  transition: stroke 0.35s, transform 0.35s, top 0.35s, color 0.35s;\n}\n\n.rotateCustomArrow {\n  top: 4px;\n  transform: rotate(-45deg);\n}\n\n.buttonWithArrow:hover .customArrow {\n  stroke: white;\n}\n\n.searchInput {\n  &::placeholder {\n    font-size: 0.9rem;\n  }\n}\n\n\n@keyframes expand {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n\n  50% {\n    transform: scale(1.5 / 2);\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(1.5);\n    opacity: 0;\n  }\n}\n\n@for $i from 1 through 5 {\n  .circle:nth-child(#{$i}) {\n    animation-delay: ($i - 1) * 1s;\n  }\n}\n\n.circle {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(circle, rgba(0, 0, 0, 0.4), rgba(255, 255, 255, 0.2));\n  border-radius: 50%;\n  animation-name: expand;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n  animation-duration: 5s;\n  pointer-events: none;\n  opacity: 0;\n}\n\n@media (max-width: 728px) {\n  .lightAccent:hover {\n    background-color: #eaeaea;\n    color: black;\n  }\n\n  .customSvg:hover {\n    fill: black;\n  }\n\n  .buttonWithArrow:hover .customArrow {\n    stroke: black;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lightAccent": `ShopDeviceList_lightAccent__jLicp`,
	"customButton": `ShopDeviceList_customButton__yffUz`,
	"buttonWithCircles": `ShopDeviceList_buttonWithCircles__BL85S`,
	"circleContainer": `ShopDeviceList_circleContainer__hKfXl`,
	"circle": `ShopDeviceList_circle__F7QPQ`,
	"buttonWithArrow": `ShopDeviceList_buttonWithArrow__X59au`,
	"filterButton": `ShopDeviceList_filterButton__IKXaV`,
	"customSvg": `ShopDeviceList_customSvg__UgQiI`,
	"customArrow": `ShopDeviceList_customArrow__RF4RL`,
	"rotateCustomArrow": `ShopDeviceList_rotateCustomArrow__FY-fe`,
	"searchInput": `ShopDeviceList_searchInput__4lDmx`,
	"expand": `ShopDeviceList_expand__GP2NL`
};
export default ___CSS_LOADER_EXPORT___;
